export enum IconCardImgSize {
  SMALL,
  MEDIUM,
  LARGE,
  FULL_WIDTH,
}
